module.exports = __webpack_public_path__ + "static/media/DTBH01.f956dfb8.jpg";